<template>
  <div class="relative flex w-full flex-col gap-24 text-[1.4rem]">
    <h3 class="heading-3">
      <slot name="title">{{ i18n(translations.title) }}</slot>
    </h3>

    <RevCard class="space-y-16 p-24">
      <GiftCardItem :image-url="assetUrl" :price />
      <RevDivider />

      <div class="body-2 flex justify-between gap-24">
        <div>{{ i18n(translations.subtotal) }}</div>
        <div class="ml-24">
          {{ i18n.price(price) }}
        </div>
      </div>
      <RevDivider />

      <div>
        <div class="space-y-4">
          <div class="body-1-bold flex justify-between">
            <div>{{ i18n(translations.total) }}</div>
            <div class="ml-24">
              {{ i18n.price(price) }}
            </div>
          </div>
        </div>

        <div
          v-if="countryCode === MarketCountryCode.US"
          class="text-static-default-low caption mt-8"
        >
          {{ i18n(translations.giftCardNonRefundable) }}
        </div>
        <GiftCardsLegalLinks />

        <div class="border-static-default-low rounded-sm mt-16 border p-8">
          <PaymentIcons :methods="GIFT_CARDS_PAYMENT_METHOD" />
          <span
            class="text-static-default-low caption-bold mt-4 flex justify-center"
          >
            <IconLockLocked size="16" />
            {{ i18n(translations.securePayment) }}
          </span>
        </div>
      </div>
    </RevCard>
  </div>
</template>

<script setup lang="ts">
import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import PaymentIcons from '@backmarket/nuxt-layer-payment/methods/PaymentIcons'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevCard } from '@ds/components/Card'
import { RevDivider } from '@ds/components/Divider'
import { IconLockLocked } from '@ds/icons/IconLockLocked'

import { GIFT_CARDS_PAYMENT_METHOD } from '~/scopes/gift-cards/constant'

import translations from './GiftCardSummary.translations'
import GiftCardItem from './components/GiftCardItem/GiftCardItem.vue'
import GiftCardsLegalLinks from './components/GiftCardsLegalLinks/GiftCardsLegalLinks.vue'

defineProps<{
  price: Price
  assetUrl: string
}>()

const i18n = useI18n()
const {
  market: { countryCode },
} = useMarketplace()
</script>
